import { IS_EXPERIMENT_VISUALIZER_ON, PRODUCTION_VISUALIZER_ENABLE_KEY, PRODUCTION_VISUALIZER_ENABLE_VALUE, WEB_UI, WEB_UI_URL, LD_FLAG, YAML, YAML_URL, CODE_SEARCH, CODE_SEARCH_URL, STASH_ITEMS_DELIMETER, IS_VISUALIZER_TEXT_ON, RELATIVE, ABSOLUTE, VISUALIZER_POSITION, IS_VISUALIZER_HOVER_ON, IS_VARIANT_REASON_ALWAYS_SHOWN, ONLY_SHOW } from '@shutterstock/experiments-constants';
import { addPageAction, getCookie, Stash } from '@shutterstock/experiments-sdk-next';

// Returns true if accessing internal site (local dev, qa, ) & is browser
// Else returns false
// Should SSR in QA, Only works client side at prod 'next.shutterstock.com'
var getIsInternalSite = function getIsInternalSite() {
  var _window$location;
  var hostname = typeof window !== 'undefined' && (_window$location = window.location) != null && _window$location.hostname ? window.location.hostname : '';
  return Boolean(hostname && hostname.indexOf('www.shutterstock.com') === -1 && hostname.indexOf('enterprise.shutterstock.com') === -1 && hostname.indexOf('submit.shutterstock.com') === -1);
};
var getIsProductionOverride = function getIsProductionOverride() {
  return getCookie(PRODUCTION_VISUALIZER_ENABLE_KEY) === PRODUCTION_VISUALIZER_ENABLE_VALUE;
};
var getIsVisualizerAllowed = function getIsVisualizerAllowed(settingKey) {
  // only care about the turn on switch, prevents over-reporting on other settings
  if (settingKey !== IS_EXPERIMENT_VISUALIZER_ON) {
    return true;
  }
  var isInternalSite = getIsInternalSite();
  var isProductionOverride = getIsProductionOverride();
  if (isInternalSite) return true;else if (isProductionOverride) {
    addPageAction({
      name: 'productionExperimentVisualizer'
    });
    return true;
  } else {
    return false;
  }
};

var isBrowser = typeof window !== 'undefined';

var getLaunchDarklyEnv = function getLaunchDarklyEnv() {
  var _window$location;
  var hostname = typeof window !== 'undefined' && (_window$location = window.location) != null && _window$location.hostname ? window.location.hostname : '';
  if (hostname && hostname.indexOf('prod.') >= 1) {
    return 'production';
  }
  // If the URL doesnt contain qa., and we are on shutterstock.com, assume we are in production
  if (hostname && hostname.indexOf('dev.') === -1 && hostname.indexOf('qa.') === -1 && hostname.indexOf('.shutterstock.com') >= 0) {
    return 'production';
  }
  return 'qa';
};
var getLdFlagUrl = function getLdFlagUrl(experimentId) {
  var env = getLaunchDarklyEnv();
  return "https://app.launchdarkly.com/shutterstock-one-experiments/" + env + "/features/" + experimentId;
};
var getExperimentLinks = function getExperimentLinks(experimentId) {
  return [{
    label: WEB_UI,
    url: "" + WEB_UI_URL + experimentId
  }, {
    label: LD_FLAG,
    url: getLdFlagUrl(experimentId)
  }, {
    label: YAML,
    url: "" + YAML_URL + experimentId
  }, {
    label: CODE_SEARCH,
    url: "" + CODE_SEARCH_URL + experimentId
  }];
};

var getQueryParamValue = function getQueryParamValue(queryParamKey) {
  return new URLSearchParams(window.location.search).getAll(queryParamKey);
};
// Resolves getting item from localStorage & query parameters with priority placed on the query parameter setting
var getQueryParamaterLocalItemArray = function getQueryParamaterLocalItemArray(settingKey, defaultVal) {
  if (!isBrowser) {
    return defaultVal;
  }
  var stash = Stash(settingKey);
  var setting = stash.value;
  var queryParameterSetting = getQueryParamValue(settingKey);
  if (queryParameterSetting.length > 0) {
    stash.setItems(queryParameterSetting);
    return queryParameterSetting;
  }
  if (setting === '') {
    return defaultVal;
  }
  return setting.split(STASH_ITEMS_DELIMETER);
};
// Resolves getting item from localStorage & query parameters with priority placed on the query parameter setting
var getQueryParamaterLocalItem = function getQueryParamaterLocalItem(settingKey, supportedVals, defaultVal) {
  if (!isBrowser || !getIsVisualizerAllowed(settingKey)) {
    return defaultVal;
  }
  var stash = Stash(settingKey);
  var setting = stash.value;
  var _getQueryParamValue = getQueryParamValue(settingKey),
    queryParameterSetting = _getQueryParamValue[0];
  var isQueryParamString = queryParameterSetting !== undefined && typeof queryParameterSetting === 'string';
  if (isQueryParamString) {
    stash.setItems([queryParameterSetting]);
    setting = queryParameterSetting;
  }
  if (setting === '') {
    return defaultVal;
  }
  return supportedVals.includes(setting) ? setting : defaultVal;
};
// Resolves getting item from localStorage & query parameters with priority placed on the query parameter setting
var getQueryParamaterLocalItemBool = function getQueryParamaterLocalItemBool(settingKey, defaultVal) {
  return getQueryParamaterLocalItem(settingKey, ['true', 'false'], defaultVal.toString()) === 'true';
};

var getIsVisualizerOn = function getIsVisualizerOn() {
  return getQueryParamaterLocalItemBool(IS_EXPERIMENT_VISUALIZER_ON, false);
};
var getIsTextOn = function getIsTextOn() {
  return getQueryParamaterLocalItemBool(IS_VISUALIZER_TEXT_ON, true);
};
var getPosition = function getPosition() {
  return getQueryParamaterLocalItem(VISUALIZER_POSITION, [ABSOLUTE, RELATIVE], RELATIVE);
};
var getIsHoverOn = function getIsHoverOn() {
  return getQueryParamaterLocalItemBool(IS_VISUALIZER_HOVER_ON, true);
};
var getIsVariantReasonAlwaysShown = function getIsVariantReasonAlwaysShown() {
  return getQueryParamaterLocalItemBool(IS_VARIANT_REASON_ALWAYS_SHOWN, true);
};
var getOnlyShow = function getOnlyShow() {
  return getQueryParamaterLocalItemArray(ONLY_SHOW, []);
};
var getSettings = function getSettings() {
  return {
    isWrapperHoverOn: getIsHoverOn(),
    isWrapperTextOn: getIsTextOn(),
    position: getPosition(),
    isVisualizerOn: getIsVisualizerOn(),
    isVariantReasonAlwaysShown: getIsVariantReasonAlwaysShown(),
    onlyShow: getOnlyShow()
  };
};

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var getVisualizerExperimentData = function getVisualizerExperimentData(evaluation) {
  return _extends({}, evaluation, {
    renderCount: 0
  });
};
var getVisualizerExperiments = function getVisualizerExperiments(evaluations) {
  var entries = Object.entries(evaluations).reduce(function (acc, _ref) {
    var _extends2;
    var id = _ref[0],
      evaluation = _ref[1];
    return _extends({}, acc, (_extends2 = {}, _extends2[id] = getVisualizerExperimentData(evaluation), _extends2));
  }, {});
  return entries;
};

export { getExperimentLinks, getIsVisualizerAllowed, getQueryParamaterLocalItem, getQueryParamaterLocalItemBool, getSettings, getVisualizerExperimentData, getVisualizerExperiments, isBrowser };
//# sourceMappingURL=index.js.map
